import { Injectable } from '@angular/core';
import { LMSpecService, LMUrlUtilService } from '@app/services';

@Injectable()
export class LMCaptchaControlService {
  public captchaValue: string;

  constructor(
    private lmUrlUtilService: LMUrlUtilService,
    private lmSpecService: LMSpecService
  ) {}

  public getCaptchaValue(): string {
    return this.captchaValue;
  }

  public setCaptchaValue(value: string): void {
    this.captchaValue = value;
  }

  public getCaptchaBase64Url(): Promise<string> {
    return this.loadCaptcha();
  }

  private loadCaptcha(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.lmSpecService.getCaptchaSpec(this.lmUrlUtilService.getCaptchaSpecUrl())
        .subscribe((response) => {
          resolve(response.base64ImageUrl);
        }, error => reject(error));
    });
  }
}
